import React from 'react';
import Button from '../../../components/ui/Button';
import Select, { type SelectChangeEvent } from '../../../components/ui/Select';

interface TaskFiltersProps {
	filterStatus: string;
	setFilterStatus: (status: string) => void;
	filterPriority: string;
	setFilterPriority: (priority: string) => void;
}

const TaskFilters: React.FC<TaskFiltersProps> = ({
	filterStatus,
	setFilterStatus,
	filterPriority,
	setFilterPriority
}) => {
	const statusOptions = [
		{ value: 'all', label: 'All Status' },
		{ value: 'assigned', label: 'Assigned' },
		{ value: 'in-progress', label: 'In Progress' },
		{ value: 'completed', label: 'Completed' },
		{ value: 'requires-follow-up', label: 'Requires Follow-up' }
	];

	const priorityOptions = [
		{ value: 'all', label: 'All Priorities' },
		{ value: 'high', label: 'High Priority' },
		{ value: 'medium', label: 'Medium Priority' },
		{ value: 'low', label: 'Low Priority' }
	];

	const handleClearFilters = (): void => {
		setFilterStatus('all');
		setFilterPriority('all');
	};

	const handleStatusChange = (event: SelectChangeEvent): void => {
		setFilterStatus(event.target.value as string);
	};

	const handlePriorityChange = (event: SelectChangeEvent): void => {
		setFilterPriority(event.target.value as string);
	};

	const hasActiveFilters = filterStatus !== 'all' || filterPriority !== 'all';

	return (
		<div className="bg-card border border-border rounded-lg p-4">
			<div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-4 sm:space-y-0 sm:space-x-4">
				<div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
					<h3 className="font-medium text-foreground">Filter Tasks</h3>

					<div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
						<Select
							value={filterStatus}
							onChange={handleStatusChange}
							options={statusOptions}
							className="w-full sm:w-40"
						/>

						<Select
							value={filterPriority}
							onChange={handlePriorityChange}
							options={priorityOptions}
							className="w-full sm:w-40"
						/>
					</div>
				</div>

				{hasActiveFilters && (
					<Button
						variant="outline"
						size="sm"
						onClick={handleClearFilters}
						iconName="X"
						iconPosition="left"
					>
						Clear Filters
					</Button>
				)}
			</div>
		</div>
	);
};

export default TaskFilters;